<h2 mat-dialog-title id="dialog-upload-duplicated-title">{{ 'upload.duplicated.title' | translate }}</h2>
<div mat-dialog-content id="dialog-upload-duplicated-content">
  <p id="dialog-upload-duplicated-message">{{ 'upload.duplicated.message' | translate:{name: data.document_name} }}</p>
</div>
<div mat-dialog-actions align="end" id="dialog-upload-duplicated-actions">
  <button mat-button mat-dialog-close="cancel" color="warn" id="dialog-upload-duplicated-cancel">{{ 'common.cancel' | translate }}</button>
  <button mat-button [mat-dialog-close]="'replace'" color="primary" id="dialog-upload-duplicated-replace">{{ 'upload.duplicated.replace' | translate }}</button>
</div>
